'use strict';

var React = require('react');
var styled = require('styled-components');
var element = require('./element-a61cbeb7.js');
var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var colorPalette = require('./color-palette-14d554dc.js');
var theme = require('./theme-aad7ebc2.js');
var defaultTheme = require('./defaultTheme-068d5ee4.js');
var reactHelmet = require('react-helmet');
var withStyles = require('./withStyles-b393a9eb.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return defaultTheme._extends({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = defaultTheme.useTheme();

  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = React__default['default'].useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[withStyles.nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/React__default['default'].createElement(defaultTheme.ThemeContext.Provider, {
    value: theme
  }, children);
}

process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: defaultTheme.PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.object, defaultTheme.PropTypes.func]).isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = withStyles.exactProp(ThemeProvider.propTypes) : void 0;
}

var html = {
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box'
};
var body = function body(theme) {
  return defaultTheme._extends({
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    backgroundColor: theme.palette.background.default,
    '@media print': {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  });
};
var styles$1 = function styles(theme) {
  return {
    '@global': {
      html: html,
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: theme.typography.fontWeightBold
      },
      body: defaultTheme._extends({
        margin: 0
      }, body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(props) {
  /* eslint-disable no-unused-vars */
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children;
      props.classes;
  /* eslint-enable no-unused-vars */

  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, children);
}

process.env.NODE_ENV !== "production" ? CssBaseline.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * You can wrap a node.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  CssBaseline['propTypes' + ''] = withStyles.exactProp(CssBaseline.propTypes);
}

var CssBaseline$1 = withStyles.withStyles(styles$1, {
  name: 'MuiCssBaseline'
})(CssBaseline);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: defaultTheme._extends({}, html, body(theme), {
      '& *, & *::before, & *::after': {
        boxSizing: 'inherit'
      },
      '& strong, & b': {
        fontWeight: theme.typography.fontWeightBold
      }
    })
  };
};
var ScopedCssBaseline = /*#__PURE__*/React__namespace.forwardRef(function ScopedCssBaseline(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className"]);

  return /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
    className: withStyles.clsx(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ScopedCssBaseline.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string
} : void 0;
var ScopedCssBaseline$1 = withStyles.withStyles(styles, {
  name: 'MuiScopedCssBaseline'
})(ScopedCssBaseline);

var AktivGroteskBoldWOFF = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_Bd.woff";

var AktivGroteskBoldWOFF2 = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_Bd.woff2";

var AktivGroteskItalicWOFF = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_It.woff";

var AktivGroteskItalicWOFF2 = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_It.woff2";

var AktivGroteskMediumWOFF = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_Md.woff";

var AktivGroteskMediumWOFF2 = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_Md.woff2";

var AktivGroteskRegularWOFF = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_Rg.woff";

var AktivGroteskRegularWOFF2 = "https://cdn.ownup.com/component-library/v2.1.2/AktivGrotesk_W_Rg.woff2";

/* eslint-disable import/extensions */
var aktivGroteskBoldFontDefinition = {
  fontFamily: 'Aktiv-Grotesk-Bold',
  src: "url(\"".concat(AktivGroteskBoldWOFF2, "\") format(\"woff2\"),\n         url(\"").concat(AktivGroteskBoldWOFF, "\") format(\"woff\")"),
  fontWeight: 'bold',
  fontStyle: 'normal',
  fontStretch: 'normal',
  fontDisplay: 'fallback'
};
var aktivGroteskItalicFontDefinition = {
  fontFamily: 'Aktiv-Grotesk-Italic',
  src: "url(\"".concat(AktivGroteskItalicWOFF2, "\") format(\"woff2\"),\n         url(\"").concat(AktivGroteskItalicWOFF, "\") format(\"woff\")"),
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  fontDisplay: 'fallback'
};
var aktivGroteskMediumFontDefinition = {
  fontFamily: 'Aktiv-Grotesk-Medium',
  src: "url(\"".concat(AktivGroteskMediumWOFF2, "\") format(\"woff2\"),\n         url(\"").concat(AktivGroteskMediumWOFF, "\") format(\"woff\")"),
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  fontDisplay: 'fallback'
};
var aktivGroteskRegularFontDefinition = {
  fontFamily: 'Aktiv-Grotesk-Regular',
  src: "url(\"".concat(AktivGroteskRegularWOFF2, "\") format(\"woff2\"),\n         url(\"").concat(AktivGroteskRegularWOFF, "\") format(\"woff\")"),
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  fontDisplay: 'fallback'
};

var MonostenC = "https://cdn.ownup.com/component-library/v2.1.2/Monosten C.otf";

/* eslint-disable import/extensions */
var monostenCFontDefinition = {
  fontFamily: 'Monosten',
  src: "url(\"".concat(MonostenC, "\") format(\"opentype\")"),
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  fontDisplay: 'fallback'
};

var P22MackinacBookEOT = "https://cdn.ownup.com/component-library/v2.1.2/P22MackinacBook.eot";

var P22MackinacBookWOFF = "https://cdn.ownup.com/component-library/v2.1.2/P22MackinacBook.woff";

var P22MackinacMediumEOT = "https://cdn.ownup.com/component-library/v2.1.2/P22MackinacMedium.eot";

var P22MackinacMediumWOFF = "https://cdn.ownup.com/component-library/v2.1.2/P22MackinacMedium.woff";

/* eslint-disable import/extensions */
var p22MackinacMediumFontDefinition = {
  fontFamily: 'P22-Mackinac-Medium',
  src: "url(\"".concat(P22MackinacMediumEOT, "?#iefix\") format(\"embedded-opentype\"),\n         url(\"").concat(P22MackinacMediumEOT, "\"),\n         url(\"").concat(P22MackinacMediumWOFF, "\") format(\"woff\")"),
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  fontDisplay: 'fallback'
};
var p22MackinacBookFontDefinition = {
  fontFamily: 'P22-Mackinac-Book',
  src: "url(\"".concat(P22MackinacBookEOT, "?#iefix\") format(\"embedded-opentype\"),\n         url(\"").concat(P22MackinacBookEOT, "\"),\n         url(\"").concat(P22MackinacBookWOFF, "\") format(\"woff\")"),
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  fontDisplay: 'fallback'
};

var commonColors$2 = {
  accordionFontColor: colorPalette.CHARCOAL_100,
  accordionBackgroundColor: colorPalette.MOSS_50,
  accordionFocusColor: colorPalette.ALOE_100,
  // line accordions
  accordionIconColor: colorPalette.ALOE_100,
  accordionBorderColor: colorPalette.MINT_100
};
var lightColors$3 = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$2), {}, {
  accordionBackgroundColor: colorPalette.WHITE_100
});
var midtoneColors$1 = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, lightColors$3), {}, {
  // line accordions
  accordionBorderColor: colorPalette.ALOE_100
});
var darkColors$4 = {
  accordionFontColor: colorPalette.WHITE_100,
  accordionBackgroundColor: colorPalette.WHITE_10,
  accordionFocusColor: colorPalette.WHITE_100,
  // line accordions
  accordionIconColor: colorPalette.WHITE_100,
  accordionBorderColor: colorPalette.WHITE_100
};
var accordionTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, commonColors$2), theme.ThemeNames.Light, lightColors$3), theme.ThemeNames.Midtone, midtoneColors$1), theme.ThemeNames.Dark, darkColors$4);

var FILL_BUTTON_PRIMARY_VARIANT = 'fillButtonPrimaryTheme';
var FILL_BUTTON_PRIMARY_ACCENT_VARIANT = 'fillButtonPrimaryAccentTheme';
var FILL_BUTTON_SECONDARY_VARIANT = 'fillButtonSecondaryTheme';
var FILL_BUTTON_SECONDARY_ACCENT_VARIANT = 'fillButtonSecondaryAccentTheme';
var ACTION_BUTTON_VARIANT = 'actionButtonTheme';
var LINE_BUTTON_VARIANT = 'lineButtonTheme';
var SOCIAL_BUTTON_VARIANT = 'socialButtonTheme';
var ICON_BUTTON_DEFAULT_VARIANT = 'defaultColors';
var ICON_BUTTON_NEUTRAL_VARIANT = 'neutralColors';
var ICON_BUTTON_ACCENT_VARIANT = 'accentColors';
var ICON_BUTTON_QUIET_VARIANT = 'quietColors';
var SLIM_BUTTON_PRIMARY_VARIANT = 'slimButtonPrimaryTheme';
var SLIM_BUTTON_SECONDARY_VARIANT = 'slimButtonSecondaryTheme';
var socialColors = {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonBackgroundColorActive: colorPalette.WHITE_100,
  buttonBorderColor: colorPalette.FOG_60,
  buttonBackgroundColorHover: colorPalette.FOG_60,
  buttonBackgroundColorFocus: colorPalette.FOG_60,
  buttonFocusColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.CHARCOAL_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100
};
var commonColors$1 = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, FILL_BUTTON_PRIMARY_VARIANT, {
  buttonFontColor: colorPalette.WHITE_100,
  buttonIconColor: colorPalette.CACTUS_100,
  buttonBackgroundColorActive: colorPalette.ALOE_100,
  buttonBackgroundColorHover: colorPalette.PINE_100,
  buttonBackgroundColorFocus: colorPalette.PINE_100,
  buttonFocusColor: colorPalette.WHITE_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100,
  buttonBorderColor: colorPalette.MINT_100
}), FILL_BUTTON_PRIMARY_ACCENT_VARIANT, {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.CHARCOAL_100,
  buttonBackgroundColorActive: colorPalette.MANGO_100,
  buttonBackgroundColorHover: colorPalette.APRICOT_60,
  buttonBackgroundColorFocus: colorPalette.APRICOT_60,
  buttonFocusColor: colorPalette.CHARCOAL_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100,
  buttonBorderColor: colorPalette.MINT_100
}), ACTION_BUTTON_VARIANT, {
  buttonFontColor: colorPalette.WHITE_100,
  buttonIconColor: colorPalette.CACTUS_100,
  buttonBackgroundColorActive: colorPalette.ALOE_100,
  buttonBackgroundColorHover: colorPalette.GRADIENT_ALOE_PINE,
  buttonBackgroundColorFocus: colorPalette.GRADIENT_ALOE_PINE,
  buttonFocusColor: colorPalette.WHITE_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100,
  buttonBorderColor: colorPalette.MINT_100
}), FILL_BUTTON_SECONDARY_VARIANT, {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.ALOE_100,
  buttonBackgroundColorActive: colorPalette.SAGE_100,
  buttonBackgroundColorHover: colorPalette.MINT_100,
  buttonBackgroundColorFocus: colorPalette.MINT_100,
  buttonFocusColor: colorPalette.ALOE_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100,
  buttonBorderColor: colorPalette.MINT_100
}), FILL_BUTTON_SECONDARY_ACCENT_VARIANT, {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.CHARCOAL_100,
  buttonBackgroundColorActive: colorPalette.MANGO_60,
  buttonBackgroundColorHover: colorPalette.APRICOT_40,
  buttonBackgroundColorFocus: colorPalette.APRICOT_40,
  buttonFocusColor: colorPalette.CHARCOAL_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100,
  buttonBorderColor: colorPalette.MINT_100
}), LINE_BUTTON_VARIANT, {
  buttonIconColor: colorPalette.CHARCOAL_100,
  buttonBackgroundColorHover: colorPalette.APRICOT_40,
  buttonBackgroundColorFocus: colorPalette.APRICOT_40,
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonBackgroundColorActive: colorPalette.MINT_100,
  buttonBorderColor: colorPalette.MINT_100,
  buttonFocusColor: colorPalette.ALOE_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100
}), SOCIAL_BUTTON_VARIANT, _rollupPluginBabelHelpers._objectSpread2({}, socialColors)), "iconButtons", _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({
  radius: '50%',
  iconSize: '1.25rem',
  iconSizeMicro: '0.75rem',
  iconSizeMicroMicro: '0.625rem',
  focusOutlineSizeMultiplier: 0.25,
  focusOutlineSpacingMultiplier: 0,
  focusOutlineSpacingLargeMultiplier: 0.25,
  focusOutlineSpacingMicroMultiplier: -0.25
}, ICON_BUTTON_DEFAULT_VARIANT, {
  color: colorPalette.ALOE_100,
  backgroundColorActive: colorPalette.SAGE_100,
  backgroundColorHover: colorPalette.MINT_100,
  backgroundColorFocus: colorPalette.MINT_100,
  focusOutlineColor: colorPalette.ALOE_100
}), ICON_BUTTON_NEUTRAL_VARIANT, {
  color: colorPalette.SLATE_100,
  backgroundColorActive: colorPalette.FOG_40,
  backgroundColorHover: colorPalette.FOG_60,
  backgroundColorFocus: colorPalette.FOG_60,
  focusOutlineColor: colorPalette.SLATE_100
}), ICON_BUTTON_QUIET_VARIANT, {
  color: colorPalette.ALOE_100,
  backgroundColorActive: colorPalette.MOSS_50,
  backgroundColorHover: colorPalette.MOSS_100,
  backgroundColorFocus: colorPalette.MOSS_100,
  focusOutlineColor: colorPalette.ALOE_100
}), ICON_BUTTON_ACCENT_VARIANT, undefined)), "slimButtons", _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, SLIM_BUTTON_PRIMARY_VARIANT, {
  buttonFontColor: colorPalette.WHITE_100,
  buttonIdleFontColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.WHITE_100,
  buttonIdleIconColor: colorPalette.CHARCOAL_100,
  buttonBackgroundColorActive: colorPalette.ALOE_100,
  buttonBackgroundColorHover: colorPalette.PINE_100,
  buttonBackgroundColorFocus: colorPalette.PINE_100,
  buttonIdleBackgroundColor: colorPalette.FOG_40,
  buttonFocusColor: colorPalette.WHITE_100
}), SLIM_BUTTON_SECONDARY_VARIANT, {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonIdleFontColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.CHARCOAL_100,
  buttonIdleIconColor: colorPalette.CHARCOAL_100,
  buttonBackgroundColorActive: colorPalette.SAGE_100,
  buttonBackgroundColorHover: colorPalette.MINT_100,
  buttonBackgroundColorFocus: colorPalette.MINT_100,
  buttonIdleBackgroundColor: colorPalette.FOG_40,
  buttonFocusColor: colorPalette.ALOE_100
}));
var buttonTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, _rollupPluginBabelHelpers._objectSpread2({}, commonColors$1)), theme.ThemeNames.Light, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1), {}, {
  iconButtons: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1.iconButtons), {}, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, ICON_BUTTON_DEFAULT_VARIANT, {
    color: colorPalette.ALOE_100,
    backgroundColorActive: colorPalette.SAGE_100,
    backgroundColorHover: colorPalette.MINT_100,
    backgroundColorFocus: colorPalette.MINT_100,
    focusOutlineColor: colorPalette.ALOE_100
  }), ICON_BUTTON_NEUTRAL_VARIANT, undefined), ICON_BUTTON_QUIET_VARIANT, undefined), ICON_BUTTON_ACCENT_VARIANT, undefined))
})), theme.ThemeNames.Midtone, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1), {}, _rollupPluginBabelHelpers._defineProperty({
  iconButtons: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1.iconButtons), {}, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, ICON_BUTTON_DEFAULT_VARIANT, {
    color: colorPalette.ALOE_100,
    backgroundColorActive: colorPalette.WHITE_50,
    backgroundColorHover: colorPalette.WHITE_60,
    backgroundColorFocus: colorPalette.WHITE_60,
    focusOutlineColor: colorPalette.ALOE_100
  }), ICON_BUTTON_NEUTRAL_VARIANT, undefined), ICON_BUTTON_QUIET_VARIANT, undefined), ICON_BUTTON_ACCENT_VARIANT, {
    color: colorPalette.WHITE_100,
    backgroundColorActive: colorPalette.ALOE_100,
    backgroundColorHover: colorPalette.PINE_100,
    backgroundColorFocus: colorPalette.PINE_100,
    focusOutlineColor: colorPalette.WHITE_100
  }))
}, LINE_BUTTON_VARIANT, {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonFontColorHover: colorPalette.WHITE_100,
  buttonFontColorFocus: colorPalette.WHITE_100,
  buttonBackgroundColorActive: colorPalette.ALOE_100,
  buttonBorderColor: colorPalette.ALOE_100,
  buttonFocusColor: colorPalette.WHITE_100,
  buttonIconColor: colorPalette.CHARCOAL_100,
  buttonBackgroundColorHover: colorPalette.APRICOT_40,
  buttonBackgroundColorFocus: colorPalette.APRICOT_40
}))), theme.ThemeNames.Dark, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1), {}, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, FILL_BUTTON_PRIMARY_VARIANT, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1[FILL_BUTTON_PRIMARY_VARIANT]), {}, {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.ALOE_100,
  buttonBackgroundColorActive: colorPalette.SAGE_100,
  buttonBackgroundColorHover: colorPalette.MINT_100,
  buttonBackgroundColorFocus: colorPalette.MINT_100,
  buttonFocusColor: colorPalette.ALOE_100
})), FILL_BUTTON_PRIMARY_ACCENT_VARIANT, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1[FILL_BUTTON_PRIMARY_ACCENT_VARIANT]), {}, {
  buttonBackgroundColorActive: colorPalette.MANGO_60,
  buttonBackgroundColorHover: colorPalette.APRICOT_40,
  buttonBackgroundColorFocus: colorPalette.APRICOT_40
})), FILL_BUTTON_SECONDARY_VARIANT, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1[FILL_BUTTON_SECONDARY_VARIANT]), {}, {
  buttonBackgroundColorActive: colorPalette.MINT_80,
  buttonBackgroundColorHover: colorPalette.CACTUS_80,
  buttonBackgroundColorFocus: colorPalette.CACTUS_80
})), FILL_BUTTON_SECONDARY_ACCENT_VARIANT, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1[FILL_BUTTON_SECONDARY_ACCENT_VARIANT]), {}, {
  buttonBackgroundColorActive: colorPalette.MANGO_100,
  buttonBackgroundColorHover: colorPalette.APRICOT_60,
  buttonBackgroundColorFocus: colorPalette.APRICOT_60
})), ACTION_BUTTON_VARIANT, {
  buttonFontColor: colorPalette.CHARCOAL_100,
  buttonIconColor: colorPalette.ALOE_100,
  buttonBackgroundColorActive: colorPalette.CACTUS_100,
  buttonBackgroundColorHover: colorPalette.GRADIENT_MINT_CACTUS,
  buttonBackgroundColorFocus: colorPalette.GRADIENT_MINT_CACTUS,
  buttonFocusColor: colorPalette.ALOE_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100,
  buttonBorderColor: colorPalette.MINT_100
}), LINE_BUTTON_VARIANT, {
  buttonBackgroundColorActive: colorPalette.MINT_100,
  buttonFontColor: colorPalette.WHITE_100,
  buttonFontColorHover: colorPalette.CHARCOAL_100,
  buttonFontColorFocus: colorPalette.CHARCOAL_100,
  buttonBorderColor: colorPalette.MINT_100,
  buttonFocusColor: colorPalette.ALOE_100,
  buttonIconColor: colorPalette.ALOE_100,
  buttonBackgroundColorHover: colorPalette.MINT_100,
  buttonBackgroundColorFocus: colorPalette.MINT_100
}), "iconButtons", _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1.iconButtons), {}, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, ICON_BUTTON_DEFAULT_VARIANT, {
  color: colorPalette.WHITE_100,
  backgroundColorActive: colorPalette.WHITE_10,
  backgroundColorHover: colorPalette.WHITE_20,
  backgroundColorFocus: colorPalette.WHITE_20,
  focusOutlineColor: colorPalette.WHITE_100
}), ICON_BUTTON_NEUTRAL_VARIANT, undefined), ICON_BUTTON_QUIET_VARIANT, undefined), ICON_BUTTON_ACCENT_VARIANT, {
  color: colorPalette.PINE_100,
  backgroundColorActive: colorPalette.SAGE_100,
  backgroundColorHover: colorPalette.MINT_100,
  backgroundColorFocus: colorPalette.MINT_100,
  focusOutlineColor: colorPalette.PINE_100
}))), SOCIAL_BUTTON_VARIANT, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors$1), socialColors))));

var BACKGROUND_COLOR_PRIMARY_VARIANT = 'primaryTheme';
var BACKGROUND_COLOR_SECONDARY_VARIANT = 'secondaryTheme';
var BACKGROUND_COLOR_TERTIARY_VARIANT = 'tertiaryTheme';
var BACKGROUND_COLOR_QUATERNARY_VARIANT = 'quaternaryTheme';
var BACKGROUND_COLOR_QUINARY_VARIANT = 'quinaryTheme';
var backgroundColorsTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, BACKGROUND_COLOR_PRIMARY_VARIANT, {
  backgroundColor: colorPalette.WHITE_100
}), BACKGROUND_COLOR_SECONDARY_VARIANT, undefined), BACKGROUND_COLOR_TERTIARY_VARIANT, undefined), BACKGROUND_COLOR_QUATERNARY_VARIANT, undefined), BACKGROUND_COLOR_QUINARY_VARIANT, undefined)), theme.ThemeNames.Light, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, BACKGROUND_COLOR_PRIMARY_VARIANT, {
  backgroundColor: colorPalette.MOSS_100
}), BACKGROUND_COLOR_SECONDARY_VARIANT, {
  backgroundColor: colorPalette.MOSS_50
}), BACKGROUND_COLOR_TERTIARY_VARIANT, {
  backgroundColor: colorPalette.FOG_20
}), BACKGROUND_COLOR_QUATERNARY_VARIANT, {
  backgroundColor: colorPalette.APRICOT_10
}), BACKGROUND_COLOR_QUINARY_VARIANT, undefined)), theme.ThemeNames.Midtone, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, BACKGROUND_COLOR_PRIMARY_VARIANT, {
  backgroundColor: colorPalette.MINT_100
}), BACKGROUND_COLOR_SECONDARY_VARIANT, {
  backgroundColor: colorPalette.SAGE_100
}), BACKGROUND_COLOR_TERTIARY_VARIANT, {
  backgroundColor: colorPalette.MYSTIC_60
}), BACKGROUND_COLOR_QUATERNARY_VARIANT, {
  backgroundColor: colorPalette.MYSTIC_40
}), BACKGROUND_COLOR_QUINARY_VARIANT, {
  backgroundColor: colorPalette.MANGO_40
})), theme.ThemeNames.Dark, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, BACKGROUND_COLOR_PRIMARY_VARIANT, {
  backgroundColor: colorPalette.ALOE_100
}), BACKGROUND_COLOR_SECONDARY_VARIANT, {
  backgroundColor: colorPalette.PINE_100
}), BACKGROUND_COLOR_TERTIARY_VARIANT, {
  backgroundColor: colorPalette.ATLANTIC_100
}), BACKGROUND_COLOR_QUATERNARY_VARIANT, {
  backgroundColor: colorPalette.ATLANTIC_90
}), BACKGROUND_COLOR_QUINARY_VARIANT, undefined));

var lightColors$2 = {
  checkboxFontColorLabel: colorPalette.CHARCOAL_100,
  checkboxColorBorder: colorPalette.ALOE_100,
  checkboxColorHover: colorPalette.SAGE_100,
  checkboxColorFocus: colorPalette.SAGE_100,
  checkboxColorSelected: colorPalette.ALOE_100,
  checkboxColorControl: colorPalette.WHITE_100,
  checkboxColorBackground: colorPalette.WHITE_100
};
var darkColors$3 = {
  checkboxFontColorLabel: colorPalette.WHITE_100,
  checkboxColorBorder: colorPalette.WHITE_100,
  checkboxColorHover: colorPalette.WHITE_20,
  checkboxColorFocus: colorPalette.WHITE_20,
  checkboxColorSelected: colorPalette.WHITE_100,
  checkboxColorControl: colorPalette.CHARCOAL_100,
  checkboxColorBackground: colorPalette.WHITE_10
};
var checkboxTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, lightColors$2), {}, {
  checkboxColorBackground: colorPalette.FOG_20
})), theme.ThemeNames.Light, lightColors$2), theme.ThemeNames.Midtone, lightColors$2), theme.ThemeNames.Dark, darkColors$3);

var whiteColors = {
  inputFontColorError: colorPalette.BERRY_100
};
var midtoneColors = {
  inputFontColorError: colorPalette.CHARCOAL_100
};
var darkColors$2 = {
  inputFontColorError: colorPalette.WHITE_100
};
var errorContainerTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, whiteColors), theme.ThemeNames.Light, whiteColors), theme.ThemeNames.Midtone, midtoneColors), theme.ThemeNames.Dark, darkColors$2);

var lightColors$1 = {
  radioButtonFontColorLabel: colorPalette.CHARCOAL_100,
  radioButtonColorBorder: colorPalette.ALOE_100,
  radioButtonColorHover: colorPalette.SAGE_100,
  radioButtonColorFocus: colorPalette.SAGE_100,
  radioButtonColorSelected: colorPalette.ALOE_100,
  radioButtonColorControl: colorPalette.WHITE_100,
  radioButtonColorBackground: colorPalette.WHITE_100
};
var darkColors$1 = {
  radioButtonFontColorLabel: colorPalette.WHITE_100,
  radioButtonColorBorder: colorPalette.WHITE_100,
  radioButtonColorHover: colorPalette.WHITE_20,
  radioButtonColorFocus: colorPalette.WHITE_20,
  radioButtonColorSelected: colorPalette.WHITE_100,
  radioButtonColorControl: colorPalette.CHARCOAL_100,
  radioButtonColorBackground: colorPalette.WHITE_10
};
var radioButtonTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, lightColors$1), {}, {
  radioButtonColorBackground: colorPalette.FOG_20
})), theme.ThemeNames.Light, lightColors$1), theme.ThemeNames.Midtone, lightColors$1), theme.ThemeNames.Dark, darkColors$1);

var commonColors = {
  inputFontColorLabelAbove: colorPalette.CHARCOAL_100,
  inputFontColorLabel: colorPalette.SLATE_100,
  inputFontColorResponse: colorPalette.CHARCOAL_100,
  inputFontColorHint: colorPalette.SLATE_100,
  inputFontColorPlaceholder: colorPalette.SLATE_50,
  inputFontColorHelp: colorPalette.CHARCOAL_100,
  inputFontColorError: colorPalette.BERRY_100,
  inputIconColorLeading: colorPalette.ALOE_100,
  inputIconColorError: colorPalette.BERRY_100,
  inputIconColorErrorBackground: colorPalette.BERRY_20,
  inputBackgroundColor: colorPalette.FOG_20,
  inputBackgroundColorActive: colorPalette.WHITE_100,
  inputBackgroundColorFocus: colorPalette.MOSS_50,
  inputBackgroundColorHover: colorPalette.MOSS_50,
  inputFocusColor: colorPalette.ALOE_100,
  inputFocusColorError: colorPalette.BERRY_100,
  inputUnderline: colorPalette.ALOE_100,
  inputLeadingIconColor: colorPalette.ALOE_100,
  inputBorderColor: colorPalette.FOG_60,
  inputBorderColorError: colorPalette.BERRY_100
};
var inputTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, _rollupPluginBabelHelpers._objectSpread2({}, commonColors)), theme.ThemeNames.Light, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors), {}, {
  inputBackgroundColor: colorPalette.WHITE_100
})), theme.ThemeNames.Midtone, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors), {}, {
  inputFontColorError: colorPalette.CHARCOAL_100,
  inputBackgroundColor: colorPalette.WHITE_100
})), theme.ThemeNames.Dark, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonColors), {}, {
  inputFontColorLabelAbove: colorPalette.WHITE_100,
  inputFontColorLabel: colorPalette.WHITE_100,
  inputFontColorResponse: colorPalette.WHITE_100,
  inputFontColorHint: colorPalette.WHITE_100,
  inputFontColorPlaceholder: colorPalette.WHITE_50,
  inputFontColorHelp: colorPalette.WHITE_100,
  inputFontColorError: colorPalette.WHITE_100,
  inputIconColorLeading: colorPalette.WHITE_100,
  inputBackgroundColor: colorPalette.WHITE_10,
  inputFocusColor: colorPalette.WHITE_100,
  inputFocusColorError: colorPalette.WHITE_100,
  inputUnderline: colorPalette.WHITE_100,
  inputLeadingIconColor: colorPalette.WHITE_100,
  inputIconColorError: colorPalette.WHITE_100
}));

var whiteTheme = {
  navigationIconColor: colorPalette.ALOE_100,
  navigationFontColorActive: colorPalette.CHARCOAL_100,
  navigationFontColorHover: colorPalette.ALOE_100,
  navigationFontColorFocus: colorPalette.ALOE_100,
  navigationFontColorSelected: colorPalette.ALOE_100
};
var navLinkTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, whiteTheme), theme.ThemeNames.Light, whiteTheme), theme.ThemeNames.Midtone, whiteTheme), theme.ThemeNames.Dark, {
  navigationIconColor: colorPalette.WHITE_100,
  navigationFontColorActive: colorPalette.WHITE_100,
  navigationFontColorHover: colorPalette.WHITE_60,
  navigationFontColorFocus: colorPalette.WHITE_100,
  navigationFontColorSelected: colorPalette.WHITE_100
});

var DEFAULT_NOTIFICATION_VARIANT = 'default';
var URGENT_NOTIFICATION_VARIANT = 'urgent';
var ERROR_NOTIFICATION_TYPE = 'error';
var WARNING_NOTIFICATION_TYPE = 'warning';
var INFO_NOTIFICATION_TYPE = 'info';
var SUCCESS_NOTIFICATION_TYPE = 'success';
var notificationThemeColors = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({
  notificationFontColor: colorPalette.CHARCOAL_100,
  notificationShadow: colorPalette.CHARCOAL_5,
  notificationBorderFocusColor: colorPalette.SLATE_100
}, DEFAULT_NOTIFICATION_VARIANT, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, ERROR_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.WHITE_100,
  notificationBorderColor: colorPalette.FOG_60,
  notificationBackgroundFillColor: colorPalette.BERRY_100
}), WARNING_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.WHITE_100,
  notificationBorderColor: colorPalette.FOG_60,
  notificationBackgroundFillColor: colorPalette.APRICOT_100
}), INFO_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.WHITE_100,
  notificationBorderColor: colorPalette.FOG_60,
  notificationBackgroundFillColor: colorPalette.WALDEN_100
}), SUCCESS_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.WHITE_100,
  notificationBorderColor: colorPalette.FOG_60,
  notificationBackgroundFillColor: colorPalette.CACTUS_100
})), URGENT_NOTIFICATION_VARIANT, _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, ERROR_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.BERRY_10,
  notificationBorderColor: colorPalette.BERRY_10,
  notificationBackgroundFillColor: colorPalette.BERRY_100
}), WARNING_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.APRICOT_10,
  notificationBorderColor: colorPalette.APRICOT_10,
  notificationBackgroundFillColor: colorPalette.APRICOT_100
}), INFO_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.MYSTIC_20,
  notificationBorderColor: colorPalette.MYSTIC_20,
  notificationBackgroundFillColor: colorPalette.WALDEN_100
}), SUCCESS_NOTIFICATION_TYPE, {
  notificationBackgroundColor: colorPalette.MOSS_100,
  notificationBorderColor: colorPalette.MOSS_100,
  notificationBackgroundFillColor: colorPalette.CACTUS_100
}));
var notificationTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, notificationThemeColors), theme.ThemeNames.Light, notificationThemeColors), theme.ThemeNames.Midtone, notificationThemeColors), theme.ThemeNames.Dark, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, notificationThemeColors), {}, {
  notificationBorderFocusColor: colorPalette.WHITE_100
}));

var commonUnderlineTheme = {
  backgroundRadius: '2px',
  focusSpacingMultiplier: 0.25,
  focusRadius: '4px'
};
var lightColorsUnderline = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonUnderlineTheme), {}, {
  fontColor: colorPalette.CHARCOAL_100,
  underlineColor: colorPalette.WALDEN_100,
  backgroundColor: colorPalette.MYSTIC_40,
  focusColor: colorPalette.WALDEN_100
});
var midtoneColorsUnderline = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonUnderlineTheme), {}, {
  fontColor: colorPalette.CHARCOAL_100,
  underlineColor: colorPalette.ATLANTIC_90,
  backgroundColor: colorPalette.WHITE_50,
  focusColor: colorPalette.ATLANTIC_90
});
var darkColorsUnderline = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonUnderlineTheme), {}, {
  fontColor: colorPalette.WHITE_100,
  underlineColor: colorPalette.MYSTIC_80,
  backgroundColor: colorPalette.WHITE_20,
  focusColor: colorPalette.MYSTIC_80
});
var commonIconTheme = {
  focusSpacingMultiplier: 0.25,
  focusRadius: '4px'
};
var lightColorsIcon = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonIconTheme), {}, {
  fontColor: colorPalette.CHARCOAL_100,
  focusColor: colorPalette.ALOE_100
});
var midtoneColorsIcon = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonIconTheme), {}, {
  fontColor: colorPalette.CHARCOAL_100,
  focusColor: colorPalette.ALOE_100
});
var darkColorsIcon = _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, commonIconTheme), {}, {
  fontColor: colorPalette.WHITE_100,
  focusColor: colorPalette.WHITE_100
});
var underlineTooltipTriggerTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, lightColorsUnderline), theme.ThemeNames.Light, lightColorsUnderline), theme.ThemeNames.Midtone, midtoneColorsUnderline), theme.ThemeNames.Dark, darkColorsUnderline);
var iconTooltipTriggerTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, lightColorsIcon), theme.ThemeNames.Light, lightColorsIcon), theme.ThemeNames.Midtone, midtoneColorsIcon), theme.ThemeNames.Dark, darkColorsIcon);

var lightColors = {
  tooltipFontColor: colorPalette.CHARCOAL_100,
  tooltipBackgroundColor: colorPalette.WHITE_100,
  tooltipBorderColor: colorPalette.FOG_60,
  tooltipBoxShadow: "4.0px 4.0px 8.0px 0px ".concat(colorPalette.CHARCOAL_5)
};
var darkColors = {
  tooltipFontColor: colorPalette.WHITE_100,
  tooltipBackgroundColor: colorPalette.CHARCOAL_90,
  tooltipBorderColor: colorPalette.CHARCOAL_90,
  tooltipBoxShadow: 'none'
};
var tooltipTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, theme.ThemeNames.White, darkColors), theme.ThemeNames.Light, darkColors), theme.ThemeNames.Midtone, darkColors), theme.ThemeNames.Dark, lightColors);

var _backgroundColorsThem, _backgroundColorsThem2, _backgroundColorsThem3, _backgroundColorsThem4;

// extend Theme to allow custom properties

var ownUpWhiteTheme = defaultTheme.createTheme({
  name: 'own-up-white',
  /**
   * Custom breakpoints a defined in ZeroHeight:
   *   {@link https://zeroheight.com/7b3231350/p/973579-breakpoints}
   *
   * Numbers indicate the _lower_ bound of the breakpoint.
   *
   * Material UI Documentation: {@link https://v4.mui.com/customization/breakpoints/#breakpoints}
   */
  breakpoints: {
    values: {
      xs: 0,
      sm: 512,
      md: 768,
      lg: 1024,
      xl: 1280
    }
  },
  spacing: 8,
  shape: {
    borderRadius: 4
  },
  typography: {
    fontFamily: '"Aktiv-Grotesk-Regular", Helvetica, sans-serif',
    fontSize: 16
  },
  inputColors: inputTheme.white,
  linkColors: theme.linkTheme.white,
  underlineLinkColors: theme.underlineLinkTheme.white,
  navLinkColors: navLinkTheme.white,
  checkboxColors: checkboxTheme.white,
  buttonColors: buttonTheme.white,
  tooltipColors: tooltipTheme.white,
  accordionColors: accordionTheme.white,
  radioButtonColors: radioButtonTheme.white,
  underlineTooltipTriggerTheme: underlineTooltipTriggerTheme.white,
  iconTooltipTriggerTheme: iconTooltipTriggerTheme.white,
  notificationColors: notificationTheme.white,
  backgroundColors: backgroundColorsTheme.white,
  errorContainerColors: errorContainerTheme.white,
  palette: {
    primary: {
      main: colorPalette.PINE_100
    },
    secondary: {
      main: colorPalette.ATLANTIC_100
    },
    error: {
      main: colorPalette.BERRY_100
    },
    background: {
      "default": (_backgroundColorsThem = backgroundColorsTheme.white.primaryTheme) === null || _backgroundColorsThem === void 0 ? void 0 : _backgroundColorsThem.backgroundColor
    },
    text: {
      primary: colorPalette.CHARCOAL_100
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        // Global font declarations
        '@font-face': [aktivGroteskBoldFontDefinition, aktivGroteskItalicFontDefinition, aktivGroteskMediumFontDefinition, aktivGroteskRegularFontDefinition, monostenCFontDefinition, p22MackinacBookFontDefinition, p22MackinacMediumFontDefinition],
        // Apply to body
        body: {
          overflowX: 'hidden',
          width: '100%',
          height: '100%',
          margin: 0,
          padding: 0
        }
      }
    },
    MuiScopedCssBaseline: {
      root: {
        // Note, any CSS rules that involve selectors must be prefixed
        //   with an & to indicate ot the JSS engine that these should
        //   not be treated as JavaScript attributes, but CSS rules.
        '& *': {
          // Apply border-box to all child elements
          boxSizing: 'border-box'
        },
        // For disabled / inactive elements, the top-level container should be set to
        //   40% opacity. Any disabled elements below that should be forced
        //   to 100% opacity so that it doesn't double-dip on the transparency
        //   change.
        '& [aria-disabled="true"],& .Mui-disabled': {
          opacity: '40%',
          '& [aria-disabled="true"],& .Mui-disabled': {
            opacity: '100%',
            // Keep Mui's hiding of original inputs
            '& input[type="radio"],& input[type="checkbox"]': {
              opacity: 0
            }
          }
        },
        '& [disabled],& .Mui-disabled': {
          opacity: '40%',
          '& [disabled],& .Mui-disabled': {
            opacity: '100%',
            // Keep Mui's hiding of original inputs
            '& input[type="radio"],& input[type="checkbox"]': {
              opacity: 0
            }
          }
        }
      }
    },
    MuiButton: {
      root: {
        '&:hover': {
          backgroundColor: undefined,
          '@media (hover: none)': {
            backgroundColor: undefined
          }
        }
      }
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true // Disable ripple on all buttons by default
    }
  }
});

// ownUpWhiteTheme extensions
var ownUpLightTheme = defaultTheme.createTheme(_rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, ownUpWhiteTheme), {}, {
  name: 'own-up-light',
  inputColors: inputTheme.light,
  linkColors: theme.linkTheme.light,
  underlineLinkColors: theme.underlineLinkTheme.light,
  navLinkColors: navLinkTheme.light,
  checkboxColors: checkboxTheme.light,
  radioButtonColors: radioButtonTheme.light,
  buttonColors: buttonTheme.light,
  tooltipColors: tooltipTheme.light,
  accordionColors: accordionTheme.light,
  underlineTooltipTriggerTheme: underlineTooltipTriggerTheme.light,
  iconTooltipTriggerTheme: iconTooltipTriggerTheme.light,
  notificationColors: notificationTheme.light,
  backgroundColors: backgroundColorsTheme.light,
  errorContainerColors: errorContainerTheme.light,
  palette: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, ownUpWhiteTheme.palette), {}, {
    background: {
      "default": (_backgroundColorsThem2 = backgroundColorsTheme.light.tertiaryTheme) === null || _backgroundColorsThem2 === void 0 ? void 0 : _backgroundColorsThem2.backgroundColor
    },
    text: {
      primary: colorPalette.CHARCOAL_100
    }
  })
}));
var ownUpMidtoneTheme = defaultTheme.createTheme(_rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, ownUpWhiteTheme), {}, {
  name: 'own-up-midtone',
  inputColors: inputTheme.midtone,
  linkColors: theme.linkTheme.midtone,
  underlineLinkColors: theme.underlineLinkTheme.midtone,
  navLinkColors: navLinkTheme.midtone,
  checkboxColors: checkboxTheme.midtone,
  radioButtonColors: radioButtonTheme.midtone,
  buttonColors: buttonTheme.midtone,
  tooltipColors: tooltipTheme.midtone,
  accordionColors: accordionTheme.midtone,
  underlineTooltipTriggerTheme: underlineTooltipTriggerTheme.midtone,
  iconTooltipTriggerTheme: iconTooltipTriggerTheme.midtone,
  notificationColors: notificationTheme.midtone,
  backgroundColors: backgroundColorsTheme.midtone,
  errorContainerColors: errorContainerTheme.midtone,
  palette: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, ownUpWhiteTheme.palette), {}, {
    background: {
      "default": (_backgroundColorsThem3 = backgroundColorsTheme.midtone.primaryTheme) === null || _backgroundColorsThem3 === void 0 ? void 0 : _backgroundColorsThem3.backgroundColor
    },
    text: {
      primary: colorPalette.CHARCOAL_100
    }
  })
}));
var ownUpDarkTheme = defaultTheme.createTheme(_rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, ownUpWhiteTheme), {}, {
  name: 'own-up-dark',
  inputColors: inputTheme.dark,
  linkColors: theme.linkTheme.dark,
  underlineLinkColors: theme.underlineLinkTheme.dark,
  navLinkColors: navLinkTheme.dark,
  checkboxColors: checkboxTheme.dark,
  radioButtonColors: radioButtonTheme.dark,
  buttonColors: buttonTheme.dark,
  tooltipColors: tooltipTheme.dark,
  accordionColors: accordionTheme.dark,
  underlineTooltipTriggerTheme: underlineTooltipTriggerTheme.dark,
  iconTooltipTriggerTheme: iconTooltipTriggerTheme.dark,
  notificationColors: notificationTheme.dark,
  backgroundColors: backgroundColorsTheme.dark,
  errorContainerColors: errorContainerTheme.dark,
  palette: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, ownUpWhiteTheme.palette), {}, {
    background: {
      "default": (_backgroundColorsThem4 = backgroundColorsTheme.dark.tertiaryTheme) === null || _backgroundColorsThem4 === void 0 ? void 0 : _backgroundColorsThem4.backgroundColor
    },
    text: {
      primary: colorPalette.WHITE_100
    }
  })
}));

var OwnUpHead = function OwnUpHead() {
  return /*#__PURE__*/React__default['default'].createElement(reactHelmet.Helmet, null, /*#__PURE__*/React__default['default'].createElement("meta", {
    name: "viewport",
    content: "minimum-scale=1, initial-scale=1, width=device-width"
  }));
};

/**
 * Applies styles to all children. Should be used if a certain
 *   section of the site differs in its theme from the root.
 *
 * @param props - See {@link OwnUpComponentLibraryProviderProps}
 */
var OwnUpThemeProvider = function OwnUpThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? ownUpWhiteTheme : _ref$theme,
    children = _ref.children;
  return (
    /*#__PURE__*/
    // Allow styled-components to also access the Material UI theme
    React__default['default'].createElement(styled.ThemeProvider, {
      theme: theme
    }, children)
  );
};

/**
 * Applies the core stylesheet to the page. You should
 *   only have one of these in your hierarchy or else
 *   your style sheets may get mixed up. Use {@link OwnUpThemeProvider}
 *   to have nested themes.
 *
 * @param children - Child elements to put inside this wrapper
 * @param props - See {@link OwnUpComponentLibraryProviderProps}
 */
var OwnUpComponentLibraryProvider = function OwnUpComponentLibraryProvider(_ref2) {
  var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? ownUpWhiteTheme : _ref2$theme,
    polyfills = _ref2.polyfills,
    children = _ref2.children;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(withStyles.StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpHead, null), /*#__PURE__*/React__default['default'].createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default['default'].createElement(CssBaseline$1, null), /*#__PURE__*/React__default['default'].createElement(ScopedCssBaseline$1, null, children)))), /*#__PURE__*/React__default['default'].createElement(element.OwnUpComponentLibraryPolyfills, polyfills));
};

exports.ACTION_BUTTON_VARIANT = ACTION_BUTTON_VARIANT;
exports.FILL_BUTTON_PRIMARY_ACCENT_VARIANT = FILL_BUTTON_PRIMARY_ACCENT_VARIANT;
exports.FILL_BUTTON_PRIMARY_VARIANT = FILL_BUTTON_PRIMARY_VARIANT;
exports.FILL_BUTTON_SECONDARY_ACCENT_VARIANT = FILL_BUTTON_SECONDARY_ACCENT_VARIANT;
exports.FILL_BUTTON_SECONDARY_VARIANT = FILL_BUTTON_SECONDARY_VARIANT;
exports.ICON_BUTTON_ACCENT_VARIANT = ICON_BUTTON_ACCENT_VARIANT;
exports.ICON_BUTTON_DEFAULT_VARIANT = ICON_BUTTON_DEFAULT_VARIANT;
exports.ICON_BUTTON_NEUTRAL_VARIANT = ICON_BUTTON_NEUTRAL_VARIANT;
exports.ICON_BUTTON_QUIET_VARIANT = ICON_BUTTON_QUIET_VARIANT;
exports.LINE_BUTTON_VARIANT = LINE_BUTTON_VARIANT;
exports.OwnUpComponentLibraryProvider = OwnUpComponentLibraryProvider;
exports.OwnUpThemeProvider = OwnUpThemeProvider;
exports.SLIM_BUTTON_PRIMARY_VARIANT = SLIM_BUTTON_PRIMARY_VARIANT;
exports.SLIM_BUTTON_SECONDARY_VARIANT = SLIM_BUTTON_SECONDARY_VARIANT;
exports.SOCIAL_BUTTON_VARIANT = SOCIAL_BUTTON_VARIANT;
exports.ScopedCssBaseline = ScopedCssBaseline$1;
exports.aktivGroteskBoldFontDefinition = aktivGroteskBoldFontDefinition;
exports.aktivGroteskItalicFontDefinition = aktivGroteskItalicFontDefinition;
exports.aktivGroteskMediumFontDefinition = aktivGroteskMediumFontDefinition;
exports.aktivGroteskRegularFontDefinition = aktivGroteskRegularFontDefinition;
exports.monostenCFontDefinition = monostenCFontDefinition;
exports.ownUpDarkTheme = ownUpDarkTheme;
exports.ownUpLightTheme = ownUpLightTheme;
exports.ownUpMidtoneTheme = ownUpMidtoneTheme;
exports.ownUpWhiteTheme = ownUpWhiteTheme;
exports.p22MackinacBookFontDefinition = p22MackinacBookFontDefinition;
exports.p22MackinacMediumFontDefinition = p22MackinacMediumFontDefinition;
//# sourceMappingURL=element-2cae4d89.js.map
